// extracted by mini-css-extract-plugin
module.exports = {"atm_gq_2efq5t":"atm_gq_2efq5t"};